module.exports = __webpack_public_path__ + "img/lb5.b66aef11.jpg";